var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-overlay',{attrs:{"show":_vm.isShow,"custom-style":{
      background: 'rgb(255, 255, 255, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      paddingTop: '40vh'
    }}},[_c('van-loading',{attrs:{"size":"24px","color":"#4994df"}},[_c('span',{staticStyle:{"color":"#4994df"}},[_vm._v(_vm._s(_vm.title || '加载中···'))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }